import React from 'react';
import { useSelector } from 'react-redux';
import InventoryLocation from './InventoryLocation';
import AddFloorMap from './AddFloorMap';

const LocationPopupProvider = () => {
    const current_modal = useSelector(state => state.location.current_modal);
    if (current_modal === 'inventory_location') {
        return <InventoryLocation
            visible={current_modal === 'inventory_location'} />;
    } else if (current_modal === 'AddFloor') {
        return <AddFloorMap
            visible={current_modal === 'AddFloor'} />;
    } else if (current_modal === 'AddZone') {
        const AddZone = React.lazy(() => import('./AddZone'));
        return <React.Suspense fallback={<div>Loading...</div>}>
            <AddZone
                visible={current_modal === 'AddZone'} />;
        </React.Suspense>
    } else if (current_modal == 'locationOptPopup') {
        const LocationOptPopup = React.lazy(() => import('./LocationOptPopup'));
        return <React.Suspense fallback={<div>Loading...</div>}>
            <LocationOptPopup
                visible={current_modal === 'locationOptPopup'} />;
        </React.Suspense>
    }

    return null;
};

export default LocationPopupProvider;
